import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

export const CAMPAIGNS_GROUP_ROUTE = `/${ENTITY_TO_PATH_MAP[ENTITY.CAMPAIGNS_GROUP]}`;
export const CAMPAIGNS_GROUP_ID_PARAM_NAME = 'campaignsGroupId';
export const CAMPAIGNS_GROUP_ID_PARAM_TEMPLATE = `/:${CAMPAIGNS_GROUP_ID_PARAM_NAME}?`;
